export default "__VITE_ASSET__55091506__"